import AppOptions from '../../../_core/ts/app/options';
import App24ur2025 from './app/app';

document.addEventListener('DOMContentLoaded', () => {
    const app = new App24ur2025((<any>window).config as AppOptions);
    (<any>window).app = app;

    app.run();
});

